import {Button, Stack} from '@mui/material';
import React, {PropsWithChildren} from 'react';

import Icon from 'presentation/icons';
import {DrawerRoot, Puller, StyledBox, StyledSwipeableDrawer} from './styles';
import {SwipeableEdgeDrawerProps} from './types';
import {DRAWER_BLEEDING} from './constants';

export function SwipeableEdgeDrawer(props: PropsWithChildren<SwipeableEdgeDrawerProps>) {
	const {open, type, setOpen, children, customDrawerHeight, rounded, zIndex} = props;

	function toggleDrawer() {
		setOpen(!open);
	}

	return (
		<DrawerRoot>
			<StyledSwipeableDrawer
				$zIndex={zIndex}
				$rounded={rounded}
				$customHeight={customDrawerHeight}
				anchor="bottom"
				open={open}
				onClose={() => setOpen(false)}
				onOpen={() => setOpen(true)}
				swipeAreaWidth={DRAWER_BLEEDING}
				allowSwipeInChildren
				disableSwipeToOpen={false}
				slotProps={{
					modal: {
						keepMounted: true,
					},
				}}>
				{type === 'with-appbar' ? (
					<StyledBox elevation={3} $open={open}>
						<Button
							onClick={toggleDrawer}
							variant="text"
							size="small"
							endIcon={
								<Icon name={open ? 'expand-more-filled' : 'expand-less-filled'} />
							}>
							{props.title}
						</Button>
					</StyledBox>
				) : (
					<Stack pt={2} pb={1} alignItems="center">
						<Puller />
					</Stack>
				)}
				{children}
			</StyledSwipeableDrawer>
		</DrawerRoot>
	);
}
